import { OnInit, Component, Optional, Inject } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { IContextService, DomainContext } from '@pershing/pershing-core';
import { NxiContextUtils } from '@pershing/nxi-common';
import { PcfService } from '../../../services/PcfService.component';
import { NxiRestService } from '../../../services/NXI-Rest.service';
import { MatDialog } from '@angular/material/dialog';
import { PershingTranslationService } from '@pershing/pershing-core';

interface TestObject {
    name: string;
    value: string;
  }

@Component({
    selector: 'Income-CashPopup',
    templateUrl: './IncomeCashPopup.component.html',
    styleUrls: ['./IncomeCashPopup.component.css']
})
export class IncomeCashPopupComponent implements OnInit {
    timeArray: TestObject[]= [{name: 'All', value: '00'},
                {name: 'Bond Interest', value: '01'},
                {name: 'Cash Dividend', value: '02'},
                {name: 'Return Of Principal', value: '04'},
                {name: 'Full Call', value: '05'},
                {name: 'Partial Call', value: '06'},
                {name: 'Pre Refund', value: '07'},
                {name: 'Long Term Capital Gain', value: '08'},
                {name: 'Short Term Capital Gain', value: '09'},
                {name: 'Pay Down', value: '10'},
                {name: 'Non Taxable Dividend', value: '11'},
                {name: 'Cash In Lieu', value: '12'},
                {name: 'Liquidating Dividend', value: '13'},
                {name: 'Coupon Bonds', value: '14'},
                {name: 'Interest On Foreign Security', value: '15'},
                {name: 'Master Limited Partnership', value: '18'},
                {name: 'Maturity', value: '19'},
                {name: 'Gnma', value: '21'},
                {name: 'Trust Distribution', value: '24'},
                {name: 'Rights Redemption', value: '25'},
                {name: 'Mutual Fund Distribution', value: '26'}
            ];
    timeArray1: TestObject[]= [{name: 'All', value: '0'},
            {name: 'Next Week', value: '1'},
            {name: 'Next Two Weeks', value: '2'},
            {name: 'Next Three Weeks', value: '3'},
            {name: 'Next 1 Month', value: '10'},
            {name: 'Next 2 Months', value: '11'},
            {name: 'Next 3 Months', value: '12'},
            {name: 'Next 6 Months', value: '15'},
            {name: 'Next 9 Months', value: '18'},
            {name: 'Next 1 Year', value: '19'}
        ];
    TypeArray: TestObject[]= [{name: 'Announced', value: '0'},
            {name: 'Announced & Projected', value: '1'},
            {name: 'Projected', value: '2'}
        ];
    timePeriod = '12';
    checkBoxVar= false;
    CashFlowType= '1';
    BondType= '00';
    subs: Subscription;
    acctRef: any;
    serviceUrl: any;
    isDisabled: Boolean = false;
    da: any;
    activeSort: any;
    reverseSort: boolean;
    sorting: boolean = true;
    data: any;
    Trd: any;
    pc: any;
    prc: any;
    down: any;
    getpanel: any;
    MainWindow: any;
    CashWidth: number= 60;
    TimeWidth: number = 135;
    DocWidth: number = 192;
    isAda: boolean = false;
    error: any;
    constructor(private contextService: IContextService, private pcfservice: PcfService, private nxiRestService: NxiRestService, private dialog: MatDialog,
                private translationService: PershingTranslationService,  @Optional() @Inject('AppSettings') appSettings: any) {
                this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
                if (appSettings.themeType === 'ada') {
                    this.isAda = true;
                }
                }
    ngOnInit() {
        this.serviceUrl = this.nxiRestService.serviceUrl;
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.acctRef = contextValue.hashValue;
            this.download();
            this.applyFilter();
        });
    }
    updateCheckBox() {
        if (this.CashFlowType === '1') {
            this.isDisabled = false;
        } else {
            this.checkBoxVar = false;
            this.isDisabled = true;
        }
    }
    applyFilter() {
        this.download();
        let params = new HttpParams()
            .set('timePeriod', this.timePeriod)
            .set('mutual_Fund_Chk', String(this.checkBoxVar))
            .set('isGDR', 'true')
            .set('doctype', this.CashFlowType);
        if ( this.BondType !== '00') {
            params = params.append('secDivDistyp', this.BondType);
        }
        this.pcfservice.IncomeCashPopup(this.serviceUrl, this.acctRef, params).subscribe(
            data => {
                this.da = data;
                for (  let i of this.da.incomingCashFlowDetails)
                {
                    if (i.acctTitle !== null) {
                    i['accountHover'] = 0;
                    i['accountWidth'] = 0;
                    i.acctTitle = i.acctTitle.replace(/ {5,}/g, '<br>') + ' - ' + i.accountId;
                    let strSplit = i.acctTitle.split('<br>');
                    let longestWord = strSplit.sort(function(a, b) {return b.length - a.length; });
                    i['accountWidth1'] = longestWord[0].length; }
                }
                this.Trd = this.da.incomingCashFlowDetails[(this.da.incomingCashFlowDetails.length) - 1 ].securityDescription;
                this.pc = this.da.incomingCashFlowDetails[(this.da.incomingCashFlowDetails.length) - 1 ].projectedCash;
                this.prc = this.da.incomingCashFlowDetails[(this.da.incomingCashFlowDetails.length) - 1].projected_Reinvestment_Cash;
            },
            err => {
                console.error(err);
                this.error = err;
            },
            () => console.log('data recieved')
        );
    }
    sort(att) {
            this.sorting = false;
            if ( att === this.activeSort) {
              this.reverseSort = !this.reverseSort;
              if (!this.reverseSort) {
                this.da.incomingCashFlowDetails.sort((a, b) => (a[att] > b[att]) || a[att] === '' ? 1 : -1);
              }else {
                this.da.incomingCashFlowDetails.sort((a, b) => (a[att] < b[att]) || a[att] === '' ? 1 : -1);
              }
            }else {
              this.activeSort = att;
              this.reverseSort = false;
              this.da.incomingCashFlowDetails.sort((a, b) => (a[att] > b[att]) || a[att] === '' ? 1 : -1);
            }
        }
    closeDialog() {
        this.dialog.closeAll();
    }
    download() {
        this.down = (this.serviceUrl + '/trading/' + this.acctRef + '/incoming-cash?isDownload=true&doctype='
        + this.CashFlowType + '&timePeriod=' + this.timePeriod + '&secDivDistyp=' + this.BondType + '&isGDR=true&mutual_Fund_Chk=' + this.checkBoxVar);
    }
    /* istanbul ignore next */
      print1(): void {
        let printContents, popupWin;
        printContents = document.getElementById('pcfDetailDialog').innerHTML;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(`
          <html>
            <head>
              <title>Print tab</title>
              <link rel="stylesheet" href="IncomeCashPopup.component.css" type="text/css" media = "print" /> ')
            </head>
            <body onload="window.print();window.close()">${printContents}</body>
          </html>`
        );
        popupWin.document.close();
    }

    widthc(value) {
        this.CashWidth = (value.length ) * 6 + 57;
    }

    widtht(value) {
        this.TimeWidth = (value.length ) * 6 + 65;
    }
    widthd(value) {
        this.DocWidth = (value.length ) * 6 + 70;
    }
}
